import { createSelector } from 'reselect';

export const selectComponent = state => state.components.lesson;

export const selectIsProgressExpanded = createSelector([selectComponent], component => component.isProgressExpanded);
